import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SchoolContextService } from '../../../services/school/school-context.service';
import { DynamicLabelService } from '../../../services/school/dynamic-label.service';
import { SchoolTypes } from '../../../interfaces/school.interface';

@Component({
  selector: 'app-school-context-demo',
  templateUrl: './school-context-demo.component.html',
  styleUrls: ['./school-context-demo.component.scss']
})
export class SchoolContextDemoComponent implements OnInit, OnDestroy {
  currentSchoolType: SchoolTypes;
  schoolConfig: any;
  allLabels: any = {};
  features: any = {};
  
  availableSchoolTypes: SchoolTypes[] = [];
  
  private destroy$ = new Subject<void>();

  constructor(
    private schoolContextService: SchoolContextService,
    private dynamicLabelService: DynamicLabelService
  ) {}

  ngOnInit(): void {
    this.availableSchoolTypes = this.schoolContextService.getAvailableSchoolTypes();
    
    // Subscribe to current school type
    this.schoolContextService.getCurrentSchoolType().pipe(
      takeUntil(this.destroy$)
    ).subscribe(type => {
      this.currentSchoolType = type;
    });

    // Subscribe to school configuration
    this.schoolContextService.getCurrentSchoolConfig().pipe(
      takeUntil(this.destroy$)
    ).subscribe(config => {
      this.schoolConfig = config;
      if (config) {
        this.features = config.features;
      }
    });

    // Subscribe to all labels
    this.dynamicLabelService.getAllLabels().pipe(
      takeUntil(this.destroy$)
    ).subscribe(labels => {
      this.allLabels = labels;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Change the school type for demonstration purposes
   */
  changeSchoolType(schoolType: SchoolTypes): void {
    this.schoolContextService.setSchoolType(schoolType);
  }

  /**
   * Get the display name for a school type
   */
  getSchoolTypeDisplayName(type: SchoolTypes): string {
    switch (type) {
      case SchoolTypes.PRIMARY:
        return 'Primary School';
      case SchoolTypes.SECONDARY:
        return 'Secondary School';
      case SchoolTypes.HIGHER:
        return 'Higher Education';
      case SchoolTypes.UNIVERSITY:
        return 'University';
      default:
        return type;
    }
  }
}
